import PropTypes from "prop-types"
import classNames from "classnames"
import { percentageFormatter } from "helpers/formatters/numbers"
import { darken } from "helpers/colors"
import Ellipsable from "components/ellipsable"

export default function ItemCell({ item, width, color, className, style, loading }) {
  const { label, value, chartWidth } = item

  return <div className={classNames("cell", className)} style={style}>
    <div className="content-wrapper">
      {!loading && <div className="chart-bar" style={{ background: darken(color, 0.7), width: chartWidth }} />}
      <div className="value-wrapper">
        <Ellipsable width={width}>{label}</Ellipsable>
        <div className="value">{percentageFormatter(value / 100)}</div>
      </div>
    </div>
  </div>
}

ItemCell.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
    chartWidth: PropTypes.string,
  }).isRequired,
  width: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.bool,
}
